import * as Yup from 'yup';

export const CreateBinSchema = Yup.object().shape({
  binName: Yup.string().min(2).required('Please provide bin name'),
  binType: Yup.string().min(2).required('Please provide bin type'),
  binStatus: Yup.string().min(2).required('Please provide bin status'),
});

export type CreateBinDataType = Yup.InferType<typeof CreateBinSchema>;

type InitialValues = {
  binName: string;
  binType: string;
  binStatus: string;
};

export const createBinInitialValues: InitialValues = {
  binName: '',
  binType: '',
  binStatus: '',
};

export interface ICreateBinResponse {}

export interface ICreateBinRequest {
  binName: string;
  binType: string;
  binStatus: boolean;
  rackId: string;
}
